import { PaginationMetadata } from '@execonline-inc/resource';
import { observer } from 'mobx-react';
import { emptyFragment } from '../../EmptyFragment';
import { T, TranslationsContext, translation } from '../../Translations';
import { whenNotOnLastPage } from './pagination';

export type PageFn = (page: number) => void;

interface Props {
  metadata: PaginationMetadata;
  displayedCount: number;
  pageFn: PageFn;
}

function LoadMore({ metadata, displayedCount, pageFn }: Props) {
  return (
    <TranslationsContext.Consumer>
      {(ts) => (
        <nav className="flex items-center justify-between py-6 px-4 sm:px-0 flex-col md:flex-row">
          <div className="-mt-px flex flex-1 sm:pb-2">
            <p className="text-sm text-gray-700">
              <T
                kind="Showing {{displayedCount}} of {{totalCount}}"
                displayedCount={displayedCount}
                totalCount={metadata.resultsCount}
              />
            </p>
          </div>
          <div className="md:-mt-px md:flex">
            <nav
              className="isolate inline-flex space-x-px"
              aria-label={translation('Pagination')(ts)}
            >
              {whenNotOnLastPage(metadata)
                .map((metadata) => (
                  <button
                    onClick={() => pageFn(metadata.currentPage + 1)}
                    className="rounded-md bg-teal-600 px-5 py-2 text-white"
                  >
                    <T kind="Load More" />
                  </button>
                ))
                .getOrElse(emptyFragment)}
            </nav>
          </div>
          <div className="mt-px flex w-0 flex-1 justify-end"></div>
        </nav>
      )}
    </TranslationsContext.Consumer>
  );
}

export default observer(LoadMore);
